import _ from 'lodash';
import { Methods, RestClient } from 'o2o_layout/lib/common/rest';

import { TypeCriteriaExport } from './models';
import { BIGDATA_CONSTANT } from '../../../../common/constant';

class DAL {
  search(criteria: TypeCriteriaExport) {
    let paramsUrl = new URLSearchParams();
    if (criteria.page) criteria.page && paramsUrl.append('page', (criteria.page - 1).toString());
    if (criteria.pageSize) criteria.pageSize && paramsUrl.append('pageSize', criteria.pageSize.toString());
    if (criteria.orderBy) criteria.orderBy && paramsUrl.append('orderBy', criteria.orderBy.toString());

    let url = BIGDATA_CONSTANT.url.console + `mngmnt-client/orgs/logs/export/search?${paramsUrl.toString()}`;

    const payload = _.omit(criteria, ['page', 'pageSize', 'orderBy']);

    var restClient = new RestClient(Methods.POST, url);
    return new Promise((resolve, reject) => {
      restClient.execute({}, payload).then(
        (response: any) => {
          const user: any = response.data;
          resolve(user);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getDistinctByField(field: string, query: string) {
    let url = BIGDATA_CONSTANT.url.console + `mngmnt-client/orgs/logs/export/${field}/distinct`;
    var restClient = new RestClient(Methods.GET, url);
    return new Promise((resolve, reject) => {
      restClient.execute({}, {}).then(
        (response: any) => {
          const user: any = response.data;
          resolve(user);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
}

export const ExportActivityDAL = new DAL();
